<div class="edit-bet-button-container">
    <button
        ds-button
        variant="filled"
        size="large"
        truncate="true"
        [kind]="buttonKind"
        [disabled]="!isButtonEnabled || buttonState() === buttonStates.Disabled || buttonState() === buttonStates.Locked"
        [loading]="buttonState() === buttonStates.Processing"
        (click)="buttonClick($event)">
        {{ buttonCaption }}
        @if (buttonState() === buttonStates.Processing || isDepositProcessing || isQuickDepositLoaderEnabled) {
            <ng-template #loadingTemplate><span class="edit-bet-button-spinner"></span> {{ buttonCaption }}</ng-template>
        }
        @if (buttonState() === buttonStates.Locked && isEpcotEnabled) {
            <vn-icon slot="start" class="locked-icon betslip-icon" name="theme-lock" size="12"></vn-icon>
        }
        @if (buttonState() === buttonStates.Locked && !isEpcotEnabled) {
            <vn-icon slot="start" class="locked-icon betslip-icon" name="theme-locked-i" size="12"></vn-icon>
        }
        @if (!isEpcotEnabled) {
            <ng-container slot="subtext" *ngTemplateOutlet="stake"></ng-container>
        }
    </button>
    @if (isEpcotEnabled) {
        <ng-container *ngTemplateOutlet="stake"></ng-container>
    }
</div>

<ng-template #stake>
    <span class="edit-bet-button-total-stake" *ngIf="showTotalStake">
        {{ siteCore.betslip.messages.TotalStake }}
        <span class="edit-bet-button-total-stake-value">{{ totalStake | bsCurrency: true }}</span>
    </span>
</ng-template>
